import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/privacy-policy' || path === '/privacy-policy/') {
      window.location.replace('/privacy-policy.html');
    } else {
      window.location.replace('/terms.html');
    }
  }, []);

  return null;
}

export default App;
